module.exports = __webpack_public_path__ + "e1e0fc774b2ec15f4e43eae247ef9ba9.svg";